import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PowerBiHomeReport from '../../components/report/PowerBiHomeReport'
import { fetchPowerbiConfig, powerBiRefreshSession } from '../../actions/reports/powerbiReport'
import { translate } from 'react-polyglot'
export function mapStateToProps (state) {
  return {
    ...state.search,
    powerbiConfig: state.powerbiReport
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchPowerbiConfig,
      powerBiRefreshSession
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(PowerBiHomeReport))
